import { createContext, useContext } from 'react';

/**
 * Places in the app's top bar that pages fill on phones (iOS navigation
 * bar): the back link of detail pages and the page title once the large
 * title has scrolled away. `AppShell` provides them, `PageHeader` renders
 * into them with a portal. Without an `AppShell` both are `null`.
 */
export interface AppBarSlots {
  back: HTMLElement | null;
  title: HTMLElement | null;
}

export const AppBarContext = createContext<AppBarSlots>({ back: null, title: null });

export function useAppBarSlots(): AppBarSlots {
  return useContext(AppBarContext);
}
